var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSuitcase = function SvgSuitcase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D96FF",
    d: "M8.25 11.25v-1.5h1.5v1.5zM7.5 4.875h3v-1.27a.22.22 0 0 0-.072-.158.22.22 0 0 0-.159-.072H7.731a.22.22 0 0 0-.159.072.22.22 0 0 0-.072.159zm-4.27 10.5q-.567 0-.961-.394a1.3 1.3 0 0 1-.394-.962v-2.956h5.25v.634q0 .29.194.484t.484.194h2.394a.66.66 0 0 0 .484-.194q.194-.194.194-.484v-.634h5.25v2.956q0 .57-.394.962a1.3 1.3 0 0 1-.962.394zM1.876 9.938V6.23q0-.57.394-.962.393-.394.962-.394h3.144v-1.27q0-.567.394-.961.393-.394.962-.394h2.538q.57 0 .962.394.394.393.394.962v1.269h3.144q.57 0 .962.394.394.393.394.962v3.707h-5.25v-.635a.66.66 0 0 0-.194-.484.66.66 0 0 0-.484-.194H7.803a.66.66 0 0 0-.484.194.66.66 0 0 0-.194.484v.634z"
  }))));
};
export default SvgSuitcase;